module.exports = __webpack_public_path__ + "static/media/hedge.8c846568.png";